<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Accueil</a></li>
                <li>Modules</li>
            </ul>
            <h2>Programme des cours du Centre de Formation Apostolique</h2>
        </div>
    </div>
    <!-- <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div> -->
</div>

<div class="courses-area ">
    <div class="container">
        
        <div class="row ptb-100">
            <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a  class="d-block image">
                            <img src="assets/img/courses/shool3.jpg" alt="image">
                        </a>
                        <!-- <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a> -->
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <!-- <img src="assets/img/user1.jpg" class="rounded-circle" alt="image"> -->
                            <span>Niveau 1</span>
                        </div>
                        <h3><a >Les fondements de la foi chrétienne</a></h3>
                        <p> <strong>1</strong> – La doctrine de la parole de Dieu</p>
                        <p><strong>2</strong> – La doctrine de Dieu</p>
                        <p><strong>3</strong> – La doctrine du Christ
                            <p><strong>4</strong> – La doctrine du Saint-Esprit (Pneumatologie)
                                <p><strong>5</strong> – La doctrine de l’homme</p>
                                    <p><strong>6</strong> – La doctrine de Satan et des démons</p> 
                                        <p><strong>7</strong> – La doctrine du péché (Sotériologie)</p>
                                            <p><strong>8</strong> – La doctrine de l’église</p>
                                                <p><strong>9</strong> – La gouvernance au sein de l’église</p>
                                                    <p><strong>10</strong> – La discipline dans l’Église</p>
                            
                        <!-- <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 15 Lessons</li>
                            <li><i class='flaticon-people'></i> 145 Students</li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a  class="d-block image">
                            <img src="assets/img/courses/school1.jpg" alt="image">
                        </a>
                        <!-- <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a> -->
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <!-- <img src="assets/img/user2.jpg" class="rounded-circle" alt="image"> -->
                            <span>Niveau 2</span>
                        </div>
                        <h3><a  >Le christianisme : sources et evolutions</a></h3>
                        <p> <strong>1</strong> – L’histoire de la Bible</p>
                            <p> <strong>2</strong> - Aperçu de l’Ancien Testament</p>
                                <p> <strong>3</strong> - Aperçu du Nouveau Testament </p>
                                    <p> <strong>4</strong> - Aperçu de l’histoire de l’église</p>
                                        <p> <strong>5</strong> – L’herméneutique</p>
                                            <p> <strong>6</strong> - Les différentes branches du christianisme</p>
                           
                        <!-- <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 20 Lessons</li>
                            <li><i class='flaticon-people'></i> 100 Students</li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a  class="d-block image">
                            <img src="assets/img/courses/school4.jpg" alt="image">
                        </a>
                        <!-- <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a> -->
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <!-- <img src="assets/img/user3.jpg" class="rounded-circle" alt="image"> -->
                            <span>Niveau 3</span>
                        </div>
                        <h3><a>Le chrétien, son cheminement et son impact</a></h3>
                        
                        <p> <strong>1</strong> – Le système Babylone </p>
                            <p> <strong>2</strong> - Le Royaume de Dieu </p>
                                <p> <strong>3</strong> - L’économe spirituel </p>
                                    <p> <strong>4</strong> - La Gestion de la vie (en cours pour les 2ème années):
                                        <span style=" font-style: italic; "> La destinée spirituelle,
                            Accomplir sa destinée (devoir et satisfaction
                         Vie professionnelle et destinée)</span> </p>
                            <p> <strong>5</strong> - La puissance de la prière de commandement </p>
                                <p> <strong>6</strong> - La réforme et le développement personnel. </p>
                            
                        <!-- <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 20 Lessons</li>
                            <li><i class='flaticon-people'></i> 150 Students</li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a  class="d-block image">
                            <img src="assets/img/courses/school5.jpg" alt="image">
                        </a>
                        <!-- <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a> -->
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <!-- <img src="assets/img/user6.jpg" class="rounded-circle" alt="image"> -->
                            <span>Niveau 4</span>
                        </div>
                        <h3><a >Les dimensions du chrétien dans les nations</a></h3>
                        <p> <strong>1</strong>- La maturité</p>
                            <p> <strong>2</strong> - La création de la nation de Dieu: 
                            <span style=" font-style: italic; ">La famille de Dieu,
                            Les caractéristiques d’un fils, 
                            Les fils spirituels
                            Les 4 Dimensions d’un fils</span></p>
                            <p> <strong>3</strong> - Les cinq dimensions du Christ </p>
                                <p> <strong>4</strong> - Marcher dans la vérité « présente » </p>
                            
                        <!-- <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 15 Lessons</li>
                            <li><i class='flaticon-people'></i> 145 Students</li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img14.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$49</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user5.jpg" class="rounded-circle" alt="image">
                            <span>Sarah Taylor</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">Oracle SQL Developer : Essentials, Tips and Tricks</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 20 Lessons</li>
                            <li><i class='flaticon-people'></i> 100 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img15.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$99</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user4.jpg" class="rounded-circle" alt="image">
                            <span>James Anderson</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">Learning A-Z™: Hands-On Python In Data Science</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 44 Lessons</li>
                            <li><i class='flaticon-people'></i> 440 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img1.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$39</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user1.jpg" class="rounded-circle" alt="image">
                            <span>Alex Morgan</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">The Data Science Course 2020: Complete Data Science Bootcamp</a></h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 15 Lessons</li>
                            <li><i class='flaticon-people'></i> 145 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img2.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$49</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user2.jpg" class="rounded-circle" alt="image">
                            <span>Sarah Taylor</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">Java Programming Masterclass for Software Developers</a></h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 20 Lessons</li>
                            <li><i class='flaticon-people'></i> 100 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img3.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$59</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user3.jpg" class="rounded-circle" alt="image">
                            <span>David Warner</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">Deep Learning A-Z™: Hands-On Artificial Neural Networks</a></h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 20 Lessons</li>
                            <li><i class='flaticon-people'></i> 150 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img4.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$39</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user6.jpg" class="rounded-circle" alt="image">
                            <span>Alex Morgan</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">Python for Finance: Investment Fundamentals & Data Analytics</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 15 Lessons</li>
                            <li><i class='flaticon-people'></i> 145 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img5.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$49</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user5.jpg" class="rounded-circle" alt="image">
                            <span>Sarah Taylor</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">Machine Learning A-Z™: Hands-On Python & R In Data Science</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 20 Lessons</li>
                            <li><i class='flaticon-people'></i> 100 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-courses-box without-boxshadow">
                    <div class="courses-image">
                        <a routerLink="/single-courses-2" class="d-block image">
                            <img src="assets/img/courses/img6.jpg" alt="image">
                        </a>
                        <a routerLink="/" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">$99</div>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user4.jpg" class="rounded-circle" alt="image">
                            <span>James Anderson</span>
                        </div>
                        <h3><a routerLink="/single-courses-2">R Programming A-Z™: R For Data Science With Real Exercises!</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li><i class='flaticon-agenda'></i> 44 Lessons</li>
                            <li><i class='flaticon-people'></i> 440 Students</li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-12 col-md-12">
                <div class="pagination-area text-center">
                    <a routerLink="/courses-2" class="prev page-numbers"><i class='bx bx-chevrons-left'></i></a>
                    <span class="page-numbers current" aria-current="page">1</span>
                    <a routerLink="/courses-2" class="page-numbers">2</a>
                    <a routerLink="/courses-2" class="page-numbers">3</a>
                    <a routerLink="/courses-2" class="page-numbers">4</a>
                    <a routerLink="/courses-2" class="next page-numbers"><i class='bx bx-chevrons-right'></i></a>
                </div>
            </div> -->
        </div>
    </div>
</div>